import { Injectable, Injector } from '@angular/core';

import { DealershipService } from './dealership.service';
import { BaseReportService } from './reportBase.service';
import type { IGetReportData } from '@shared/models';

@Injectable()
export class ReportDealershipService extends BaseReportService implements IGetReportData {
    private dealershipService: DealershipService;

    constructor(injector: Injector) {
        super(injector);
        this.dealershipService = injector.get(DealershipService);
    }

    public async getReportData(): Promise<any> {
        const allRows: any[] = [];
        let reportColValues: string[] = [];
        let rowInfo: any;

        const dealership = await this.dealershipService.get();
        const phoneNumber = this.utilsService.formatPhoneNumberForDisplay(dealership.phoneNumber);
        const coordinate = `(${dealership.address.coordinate.latitude}, ${dealership.address.coordinate.longitude})`;

        // let text = 'Dealership Name:  ' + dealership.dealershipName;
        // this.addSummaryRow([text], allRows);

        // text = 'Address:  ' + dealership.address.fullAddress;
        // this.addSummaryRow([text], allRows);
        
        // text = 'Coordinate:  ' + coordinate;
        // this.addSummaryRow([text], allRows);
        
        // text = 'Phone Number:  ' + phoneNumber;
        // this.addSummaryRow([text], allRows);

        reportColValues = ['Dealership Name', dealership.dealershipName];
        rowInfo = this.buildRowInfo(reportColValues, 'data');
        allRows.push(rowInfo);

        reportColValues = ['Address', dealership.address.fullAddress];
        rowInfo = this.buildRowInfo(reportColValues, 'data');
        allRows.push(rowInfo);

        reportColValues = ['Phone Number', phoneNumber];
        rowInfo = this.buildRowInfo(reportColValues, 'data');
        allRows.push(rowInfo);

        reportColValues = ['Coordinate', coordinate];
        rowInfo = this.buildRowInfo(reportColValues, 'data');
        allRows.push(rowInfo);


        // this.addSummaryRow(['Dealership Name:', dealership.dealershipName], allRows);
        // this.addSummaryRow(['Address:', dealership.address.fullAddress], allRows);
        // this.addSummaryRow(['Coordinate:', coordinate], allRows);
        // this.addSummaryRow(['Phone Number:', phoneNumber], allRows);
        
        allRows.push(undefined);
        const reportData = { 'data': allRows };
        return reportData;
    }
}
